module.exports = __webpack_public_path__ + "static/media/add.d0121d1d.svg";